<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
        <!-- 复合下拉框 -->
        <CompositeFormSelect ref="comFormSelect" :options="selectKeyOptions" :valueOptionsData="selectValueOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormSelect>
        <!-- 复合搜索框 -->
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`普通运单_自有车辆_已完成`)">导出</el-button>
        </el-form-item>

        <!-- 过磅单导出 -->
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
            <i v-if="!btnloading" class="el-icon-folder"></i>
            导出
          </el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :tableHeight="tableHeight" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" @onSortChange="onSortChange">
      <template slot="isvoice" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="'2'" :inactiveValue="`1`" @onToggle="toggleDisplay"></MySwitch>
      </template>
      <template slot="times" slot-scope="params">
        <div v-if="params.params.times == 1" class="overTime type1">
          已到期
        </div>
        <div v-if="params.params.times == 2" class="overTime type2">
          快到期
        </div>
        <div v-if="params.params.times == 3" class="overTime type0">
          未到期
        </div>
      </template>
      <template slot="status" slot-scope="params">
        <div class="overTime"
          :class="[params.params.status == '1' ? 'type2' : '', params.params.status == '2' ? 'type0' : '', params.params.status == '3' ? 'type1' : '', params.params.status == null ? 'type4' : '',]">
          {{ params.params.status == '1' ? '已到期' : '' }}
          {{ params.params.status == '2' ? '快到期' : '' }}
          {{ params.params.status == '3' ? '未到期' : '' }}
          {{ !params.params.status ? '-' : '' }}
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        ischeck: 1,
        isstatus: 4,
      },
      formCtrl: [
        // {
        //   label: "过磅单：",
        //   keyName: "isvoice",
        //   type: "select",
        //   options: [
        //     { label: '全部', value: '' },
        //     { label: '未回收', value: 1, },
        //     { label: '已回收', value: 2, },
        //   ],
        // },
        // {
        //   label: "逾期状态：",
        //   keyName: "status",
        //   type: "select",
        //   options: [
        //     { label: '全部', value: '' },
        //     { label: '已到期', value: 1, },
        //     { label: '快到期', value: 2, },
        //     { label: '未到期', value: 3, },
        //   ],
        // },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 110 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "isvoice", label: "回收过磅单", slot: "isvoice", minwidth: 120 },
        // { keyName: "times", label: "是否逾期", slot: "times", minwidth: 120 },
        { keyName: "status", label: "是否逾期", minwidth: 120, slot: "status" },
      ],
      btns: [
        {
          class: 'dispatchbtn',
          title: '再派一单',
          img: require('@/assets/img/icon-paidan.png'),
          unimg: require('@/assets/img/icon-paidan-hover.png'),
          cb: ({ id }) => {
            this.$router.push(`/order/nocontractadd?id=${id}`)
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/nocontractview4?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id }) => {
            console.log(id)
            let mode = 'view'
            if ([1].includes(this.user.user_group_id)) {
              mode = 'edit'
            }
            this.$router.push(
              `/order/nocontractfee?id=${id}&mode=${mode}`
            );
          },
        },
      ],
    };
  },
  methods: {
    onSortChange({ prop, order }) {
      // console.log({ ...column })
      // console.log(prop)
      // console.log(order)
      if (prop) this.formInline['authname'] = prop
      if (order) this.formInline['type'] = (order.replace('ending', ''))
      // console.log({ ...this.formInline })
      this.getList()
    },
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const o = this.dataObjHandler(v)
          o.open = v.isvoice + ''
          return o
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      let url = `order/upstatus`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: this.delete,
      })
    }
    const viewbtn = {
      ...this.viewBtn,
      cb: ({ id }) => {
        this.$router.push(
          `/order/nocontractview4?id=${id}&mode=view`
        );
      },
    }
    if ([5].includes(user_group_id)) {
      this.btns[1] = viewbtn
    }
    const feebtn = this.btns[2]
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns = [
        viewbtn,
        feebtn,
      ]
    }
  },
};
</script>

<style lang="less" scoped>
.row2 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
  height: 40px;
  position: relative;

  /deep/ .itemm {
    position: absolute;
    right: 0;
  }
}

.table-wrap {
  /deep/ .el-table {
    .el-switch {
      &.inactive {
        .el-switch__core::after {
          content: '否';
          line-height: 17px;
          text-indent: 18px;
          color: #fff;
        }
      }

      &.active {
        .el-switch__core::after {
          content: '是';
          line-height: 17px;
          text-indent: -34px;
          color: #fff;
        }
      }
    }

    .overTime {
      // width: 14px;
      // height: 14px;
      // border-radius: 100%;
      // display: inline-block;
      // vertical-align: top;
      // margin-top: 7px;
      color: #ffe100;

      &.type1 {
        color: #98e098;
      }

      &.type2 {
        color: #fd5b5b;
      }

      &.type4 {
        color: #333;
      }
    }
  }
}

/deep/ .el-button.is-circle {
  padding: 5px;
  color: #96999f;
  background: #f2f6fc;
}
</style>
